'use strict'

import { HTTP, login, accountService } from '../../services/account-services'
import VueLadda from 'vue-ladda'
import { default as swal } from 'sweetalert2'
import { LOGIN_SUCCESSFUL } from '../../events'

export default {
  components: {
    'vue-ladda': VueLadda
  },
  data() {
    return {
      credentials: {},
      loginError: false,
      loading: false,
      loading1: false,
      login: true,
      forgetPass: false
    }
  },
  beforeMount() {
    // let prevRoute = localStorage.getItem('previousRoute')
    // if (prevRoute === '/login') {
    //   this.$router.push('/')
    // }
  },
  methods: {
    previousStep() {
      this.$parent.activeStep--
    },
    signin() {
      this.loading = true
      login(this.credentials)
        .then((result) => {
          localStorage.setItem('authToken', result.data.id)
          localStorage.setItem('userId', result.data.userId)
          localStorage.setItem('ttl', result.data.ttl)
          localStorage.setItem('previousRoute', this.$route.path)
          this.saveAccountInfo(result.data.userId, result.data.id)
        })
        .catch((err) => {
          console.error(err)
          if (err) {
            this.loginError = true
            this.loading = false
          }
        })
    },
    register() {
      if (this.$route.path === '/checkout') {
        this.$parent.showSignupForm = true
      } else {
        this.$router.push('/signup')
      }
    },
    saveAccountInfo(userId, token) {
      HTTP
        .get(`/accounts/${userId}?access_token=${token}`)
        .then((result) => {
          console.log('Result', result.data);
          localStorage.setItem('firstName', result.data.firstName)
          localStorage.setItem('lastName', result.data.lastName)
          localStorage.setItem('username', result.data.username)
          localStorage.setItem('email', result.data.email)
          localStorage.setItem('phoneNumber', result.data.phoneNumber)
          localStorage.setItem('avatarUrl', result.data.avatarUrl || '')
          accountService.$emit(LOGIN_SUCCESSFUL, result.data.avatarUrl)
          this.$router.push({path: '/checkout'})
          location.reload()
        })
        .catch(function (error) {
          console.error(error)
        })
    },
    switchForgetPass() {
      this.login = false
      this.forgetPass = true
    },
    switchLoging() {
      this.forgetPass = false
      this.login = true
    },
    resetPass() {
      this.loading1 = true
      let email = this.credentials.email
      HTTP.get(`/accounts/forgotPassword?email=${email}`).then((result) => {
        this.loading1 = false
        swal(
          'Success !',
          'A link has been send to ' + email + ' to reset your Password !',
          'success'
        )
      }).catch((error) => {
        this.loading1 = false
        swal(
          'Hoops !',
          'Some thing is wrong :' + error,
          'error'
        )
      })
    }
  },
  props: [
    'loggedIn',
    'progress'
  ]
}



// WEBPACK FOOTER //
// ./src/components/Login/Login.js